import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function FAQSection() {
  const {
    t
  } = useLanguage();
  const faqs = [{
    question: t('faq.q1'),
    answer: t('faq.a1')
  }, {
    question: t('faq.q2'),
    answer: t('faq.a2')
  }, {
    question: t('faq.q3'),
    answer: t('faq.a3')
  }, {
    question: t('faq.q4'),
    answer: t('faq.a4')
  }, {
    question: t('faq.q5'),
    answer: t('faq.a5')
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-brand-bg py-16 md:py-24" data-id="element-15">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy" data-id="element-18">
            {t('faq.title')}
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-19">
          {faqs.map((faq, index) => <motion.div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} data-id="element-20">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-inset" data-id="element-21">
                <span className="text-lg font-semibold text-brand-navy pr-4" data-id="element-22">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-brand-primary flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-23" />
              </button>
              <AnimatePresence data-id="element-24">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-25">
                    <div className="px-6 pb-6 text-brand-text" data-id="element-26">
                      <p data-id="element-27">{faq.answer}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}